import React, { useRef, useEffect } from 'react';

const BotText = ({ element }) => {
    const msgRef = useRef();

    useEffect(() => {
        if (element && typeof element === 'string' && element.trim() !== '') {
            msgRef.current.innerHTML = element;
        } else if (element && typeof element !== 'string') {
            msgRef.current.innerHTML = JSON.stringify(element);
        }
    }, [element]);

    return (
            <p ref={msgRef}></p>
    );
}

export default BotText;
